export const useBulletStyles = () => {
    const BulletMainAuthor = "before:content-[''] before:absolute before:left-0 before:top-2 before:w-3 before:h-3 before:bg-textRedLight before:rounded-none";
    const BulletMajorAuthor = "before:content-[''] before:absolute before:left-0 before:top-2 before:w-3 before:h-3 before:bg-textGrey before:rounded-full";
    const BulletCommon = "before:content-[''] before:absolute before:left-0 before:top-2 before:w-3 before:h-3 before:rounded-full before:border-2 before:border-textGrey";

    return { BulletMainAuthor, BulletMajorAuthor, BulletCommon };
};